module.exports = __webpack_public_path__ + "media/משקפיים.03492d8c.mp3";